import { REDUCE_CANCELLATION_RESULT } from '../../constants/actions/policy';

export function reduceCancellationResult(payload) {
    return {
        type: REDUCE_CANCELLATION_RESULT,
        payload,
    };
}
